<script>
/**
 * ****************************************************************************
 * @description     :   Main component for page Login
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – phuongdt@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import template from './template.html';

/**
 * Define component chat for show page chat
 */
var SamplePopupSearch = {
    template: template,
    props: {
        onSelected: Function
    },
    created() {
        this.search();
    },
    data() {
        return {
            resultSearch: []
        };
    },
    methods: {
        search: function () {
            this.resultSearch = [
                {
                    id: 1,
                    name: '〇〇〇〇〇〇〇〇',
                    col1: 'XXXXXX',
                    col3: '□□□□□□□□',
                    col4: '△△△△△△△△'
                },
                {
                    id: 2,
                    name: '●●●●●●●●',
                    col1: 'XXXXXX',
                    col3: '■■■■■■■■',
                    col4: '▲▲▲▲▲▲▲▲'
                },
                {
                    id: 3,
                    name: '〇〇〇〇〇〇〇〇',
                    col1: 'XXXXXX',
                    col3: '□□□□□□□□',
                    col4: '△△△△△△△△'
                }
            ];
        },
        selectFirstRow() {
            if (this.resultSearch && this.resultSearch.length > 0 && this.onSelected) {
                this.onSelected(this.resultSearch[0]);
            }
        },
        selectRow(item) {
            if (this.onSelected) {
                this.onSelected(item);
            }
        }
    }
};
export default SamplePopupSearch;
</script>
